import { createSelector } from 'reselect';

const selectRewardsButton = state => state.get('rewardsButton');

export const selectNewRewardsCount = () =>
  createSelector(selectRewardsButton, data => data.get('newRewardsCount'));
